module.exports = __webpack_public_path__ + "img/arrow_right.3fcb9bc3.svg";